import React from "react";
import "./codepen_portfolio.css";

const CodepenPortfolio = () => {
	return <div>codepen_portfolio</div>;
};

export default CodepenPortfolio;
